export enum InitialsAvatarSize {
  /** The 40px avatar in an account row. */
  SMALL = 'small',
  /** The 64px avatar on the single-account card. */
  LARGE = 'large',
}

/** The design's three-colour palette (D57), one slot per saved account; the server assigns the slot. */
export const INITIALS_AVATAR_COLOUR_SLOT_COUNT = 3;

export interface InitialsAvatarProps {
  name: string;
  colourSlot: number;
  size: InitialsAvatarSize;
}
